import { NgModule } from '@angular/core';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { PageLoaderComponent } from './layout/page-loader/page-loader.component';
import { SidebarComponent } from './layout/sidebar/sidebar.component';
import { RightSidebarComponent } from './layout/right-sidebar/right-sidebar.component';
import { AuthLayoutComponent } from './layout/app-layout/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layout/app-layout/main-layout/main-layout.component';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { fakeBackendProvider } from './core/interceptor/fake-backend';
import { ErrorInterceptor } from './core/interceptor/error.interceptor';
import { JwtInterceptor } from './core/interceptor/jwt.interceptor';
import { NgxSpinnerModule } from 'ngx-spinner';
import {
  PerfectScrollbarModule,
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface
} from 'ngx-perfect-scrollbar';
// import { ClickOutsideModule } from 'ng-click-outside';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient
} from '@angular/common/http';
import { WINDOW_PROVIDERS } from './core/service/window.service';
import { JwtModule } from '@auth0/angular-jwt';
import { environment } from 'src/environments/environment';
import { BlockUIModule } from 'ng-block-ui';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from './components/sent-request-model/modal.component';
import { CreateEmailModalComponent } from './components/create-email-modal/create-email-modal.component';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { ToastrModule } from 'ngx-toastr';
import { HomeComponent } from './pages/home/home.component';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { UserProfileResolver } from './core/resolvers/user.resolver';
import { UserProfileService } from './core/service/userProfile.service';
import { OutsideProfileComponent } from './authentication/outside-profile/outside-profile.component';
import {
  DxAutocompleteModule, DxButtonModule, DxCheckBoxModule, DxDataGridModule, DxDropDownBoxModule, DxListModule, DxPopupModule,
  DxScrollViewModule, DxSelectBoxModule, DxTagBoxModule, DxTemplateModule, DxTextAreaModule, DxTreeListModule, DxTreeViewModule,
  DxTextBoxModule, DxFormModule, DxDateBoxModule, DxValidatorModule, DxValidationSummaryModule
} from 'devextreme-angular';
import { HubService } from './core/service/hub.service';
// import { ProfileComponent } from './pages/profile/profile.component';
// import { SignaturePadModule } from 'angular2-signaturepad';
// import { SignaturePadModule } from '@ng-plus/signature-pad';
// import { AngularSignaturePadModule } from 'angular-signature-pad';
// import { SignaturePadModule } from '@almothafar/angular-signature-pad';
import { CountdownModule } from 'ngx-countdown-2';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false
};

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

export function tokenGetter() {
  return localStorage.getItem('token');
}

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        FooterComponent,
        PageLoaderComponent,
        SidebarComponent,
        RightSidebarComponent,
        AuthLayoutComponent,
        MainLayoutComponent,
        OutsideProfileComponent,
        // ProfileComponent,
        // TestComponent,
        // SentRequestsComponent,
        // ModalComponent,
        // CreateEmailModalComponent,
    ],
    imports: [   
       
    HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        BlockUIModule.forRoot(),
        ToastrModule.forRoot(),
        DxAutocompleteModule, DxButtonModule, DxCheckBoxModule, DxDataGridModule, DxDropDownBoxModule, DxListModule, DxPopupModule,
        DxScrollViewModule, DxSelectBoxModule, DxTagBoxModule, DxTemplateModule, DxTextAreaModule, DxTreeListModule, DxTreeViewModule,DxValidatorModule,
        DxTextBoxModule, DxFormModule, DxDateBoxModule,DxValidationSummaryModule,
        // AngularSignaturePadModule.forRoot(),
        // AngularSignaturePadModule.forRoot(),
        BrowserModule,
        NgbModule,
        // SignaturePadModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
        JwtModule.forRoot({
            config: {
                tokenGetter,
                allowedDomains: [environment.domainUrl],
                disallowedRoutes: [environment.domainUrl + '/api/auth']
            }
        }),
        PerfectScrollbarModule,
        NgxSpinnerModule,
        CoreModule,
    ],
    providers: [
        // { provide: LocationStrategy, useClass: HashLocationStrategy },
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        // { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        // fakeBackendProvider,
        WINDOW_PROVIDERS,
        UserProfileResolver,UserProfileService,HubService
    ],
    bootstrap: [AppComponent],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ]
})
export class AppModule { }

// platformBrowserDynamic().bootstrapModule(AppModule);
